export default {
  'country': 'Canada',
  'states': [
    'Alberta',
    'British Columbia',
    'Manitoba', 'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia', 'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Saskatchewan'
  ]
}



// WEBPACK FOOTER //
// ./src/assets/countries/canada.ts